import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { AuthenticationService } from '../../../services/auth.service';

@Component({
  selector: 'app-auth-callback',
  standalone: true,
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.css'],
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly authService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      const token =
        params['token'] ||
        params['access_token'] ||
        params['lr-token'];
      if (token && token !== 'undefined') {
        sessionStorage.setItem('token', token);
        this.router.navigate(['', 'home'], { replaceUrl: true }).then(() => {
          try {
            const url = new URL(window.location.href);
            if (url.hash.includes('token=') || url.hash.includes('access_token')) {
              window.history.replaceState(
                null,
                '',
                `${url.origin}${url.pathname}${url.hash.split('?')[0]}`
              );
            }
          } catch {
            /* ignore URL cleanup failures */
          }
        });
      } else {
        this.authService.navigateToLoginRadius();
      }
    });
  }
}
